import httpClient from '@/lib/httpClient.js'
import { useQuery } from '@tanstack/react-query'

export default function useGetTransactionCategory({ id } = {}) {
  const fetchData = async () => {
    const response = await httpClient.get(`/team/transaction-category/${id}`)
    return { ...response.data.data, entity_type: 'transaction_category' }
  }

  return useQuery({
    queryKey: ['transaction-categories', 'detail', id],
    queryFn: fetchData,
    enabled: !!id,
  })
}
